import { Camera, CameraResultType, CameraSource, CameraDirection} from '@capacitor/camera';

export async function tomarFoto(){
  const fotoCamara = await Camera.getPhoto({
    resultType  : CameraResultType.Uri,
    source      : CameraSource.Camera,
    direction   : CameraDirection.Rear,
    quality     : 100
  });
  const nombreArchivo  = new Date().getTime() + '.jpeg';
  const foto = {
    filepath    : nombreArchivo,
    webviewPath : fotoCamara.webPath
  };
  return foto;
}

export async function subirFoto(){
  const fotoCamara = await Camera.getPhoto({
    resultType  : CameraResultType.Uri,
    source      : CameraSource.Photos,
    direction   : CameraDirection.Rear,
    quality     : 100
  });
  const nombreArchivo  = new Date().getTime() + '.jpeg';
  const foto = {
    filepath    : nombreArchivo,
    webviewPath : fotoCamara.webPath
  };
  return foto;
}